import React from 'react';

const AboutUs = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['business', 'groups', 'history', 'emoji_events', 'handshake', 'verified', 'star', 'engineering'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              About Us
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              About Bel-Aire Mechanical
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Arizona's largest mechanical contractor, serving the state since 1986 with excellence and innovation
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Company Overview */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Bel-Aire Mechanical - Arizona's Mechanical Contractor</h2>
            <p>Three decades of excellence in mechanical contracting and manufacturing</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical is Arizona's mechanical contractor. We are centrally located in Phoenix, AZ. Our principal corporate office building and expanded pipe, plumbing and sheet metal manufacturing facilities are all <strong style={{color: 'var(--accent-blue)'}}>state-of-the-art</strong>.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical, an Arizona corporation, was formed in September of 1986. We are a full service Mechanical HVAC and Plumbing Contractor. <strong style={{color: 'var(--accent-blue)'}}>Bel-Aire Mechanical is the largest Mechanical/Plumbing Contractor in the State of Arizona</strong>. James E. Dinan, President and CEO, is actively involved in the daily operations of the company. We take pride in constructing quality projects on time and within budget while exceeding our client's expectations.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Bel-Aire Mechanical Corporate Office Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto', marginBottom: '3rem'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                Our diversity makes no project either too small or too large for our experienced teams to execute the work in an open and trusting atmosphere. Due to our extensive amount of experience, we thoroughly understand the stringent requirements and rigorous standards that must be absolutely adhered to for the highest levels of quality and acceptance necessary for any project.
              </p>
            </div>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Santa Fe Business Park Facility Image]
            </div>
            
            <div>
              <h3 style={{fontSize: '1.5rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>Santa Fe Business Park Facility</h3>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                To better serve our Business Partners, Corporate Clients, and General Contractors, Bel-Aire Mechanical purchased a <strong style={{color: 'var(--accent-blue)'}}>5+ acre industrial property with an existing building in the Santa Fe Business Park</strong> (centrally located in Phoenix, Arizona).
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                The entire complex was totally retrofitted to encompass a <strong style={{color: 'var(--accent2-red)'}}>42,000-square-foot high bay facility that house 16,000-square-feet of offices, support space and dedicated fabrication areas</strong> with room for future growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Our Experience */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Our Experience</h2>
            <p>Three decades of diverse mechanical contracting excellence</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Over the last 30 years we have become diverse in what we offer our clients. Our experience ranges from <strong style={{color: 'var(--accent-blue)'}}>multi-million dollar Greenfield design assist projects and million dollar retro-fits to Service and Maintenance Contracts</strong> for HVAC and Plumbing. Bel-Aire Mechanical has consistently demonstrated the ability to work and thrive within any construction environment.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                We understand the construction application processes for projects built under stringent installation conditions. Our Design Build/Design Assist knowledge coupled with our experience to understand the exacting needs of any critical facility allows Bel-Aire to bring value and tangible benefits to your project.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [30 Years of Experience Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="about-us-cards-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '2rem'
            }}>
              <div className="about-us-card about-us-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)'
              }}>
                <div className="about-us-card-icon" style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>build</span></div>
                <h3 className="about-us-card-title" style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Service Department</h3>
                <p className="about-us-card-text" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Comprehensive repair, start-up, maintenance and retro-fits for all HVAC and plumbing systems.</p>
                <ul className="about-us-card-list" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Highly trained technicians for all equipment types</li>
                  <li>From largest chillers to smallest window units</li>
                  <li>Low temperature equipment specialists</li>
                  <li>24/7 Emergency Answering service</li>
                  <li>Two hour response time guarantee</li>
                </ul>
              </div>
              
              <div className="about-us-card about-us-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)'
              }}>
                <div className="about-us-card-icon" style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 className="about-us-card-title" style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Manufacturing Excellence</h3>
                <p className="about-us-card-text" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>State-of-the-art manufacturing of piping, plumbing and sheet metal components.</p>
                <ul className="about-us-card-list" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Certified welding operators with ample workspace</li>
                  <li>Multiple interior and exterior crane hoists</li>
                  <li>State-of-the-art computerized equipment</li>
                  <li>One-of-a-kind architectural and specialty items</li>
                  <li>IPD, LEAN and Last Planner approach</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '3rem auto 0'}}>
            <div style={{background: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'}}>
              <h3 style={{fontSize: '1.5rem', color: 'var(--accent-blue)', marginBottom: '1rem', textAlign: 'center'}}>Manufacturing Philosophy</h3>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                Our modular manufacturing mentality reduces the total manpower required to complete any project, provides more access for other trades and contributes to the overall substantial cost savings in labor and material through strict monitoring of productivity and material waste.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
